/**
 * Small inline SVG icons, built with the DOM API rather than innerHTML so the
 * "no innerHTML" rule holds with no exceptions. Stroke-based and `currentColor`,
 * so they follow the button's text colour in light and dark themes.
 */

const SVG_NS = "http://www.w3.org/2000/svg";

function icon(paths: readonly string[]): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("width", "18");
  svg.setAttribute("height", "18");
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("stroke-width", "2");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");
  // Decorative: the button carries the accessible name.
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  for (const d of paths) {
    const path = document.createElementNS(SVG_NS, "path");
    path.setAttribute("d", d);
    svg.appendChild(path);
  }
  return svg;
}

/** Arrow down into a tray. */
export function downloadIcon(): SVGSVGElement {
  return icon(["M12 3v12", "M7 10l5 5 5-5", "M4 20h16"]);
}

/** Trash can. */
export function trashIcon(): SVGSVGElement {
  return icon(["M4 7h16", "M10 11v6", "M14 11v6", "M6 7l1 13h10l1-13", "M9 7V4h6v3"]);
}
